import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/options`;

export const ROUTE: RouteDefinition = `${baseRoute}/options`;

export const URL = (): RouteDefinition => `${baseRoute}/options`;
